// src/routes/PlatformAdminRoutes.js
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import PlatformAdminLayout from '../components/layout/PlatformAdminLayout';
import ModuloGuard from '../components/ModuloGuard';
import PlatformAdminDashboard from '../pages/PlatformAdminDashboard';
import PlatformAdminConfiguracion from '../pages/PlatformAdminConfiguracion';
import PlatformAdminNotificaciones from '../pages/PlatformAdminNotificaciones';
import ListaFraccionamientos from '../pages/ListaFraccionamientos';
import RegistrarFraccionamiento from '../pages/RegistrarFraccionamiento';
import GestionaSolicitudes from '../pages/GestionaSolicitudes';
import SolicitudesSoporte from '../pages/SolicitudesSoporte';
import EditarFraccionamiento from '../pages/EditarFraccionamiento';
import GestionPlanes from '../pages/GestionPlanes';
import Comunidad from '../pages/Comunidad';
import ChatComunitario from '../pages/ChatComunitario';
import ValidacionDocumentos from '../pages/ValidacionDocumentos';
import GestionarUsuariosAutenticados from '../pages/GestionarUsuariosAutenticados';
import GestionAgregarNuevo from '../pages/GestionAgregarNuevo';
import ControlSesiones from '../pages/ControlSesiones';
import MetricasPlataforma from '../pages/MetricasPlataforma';
import PlatformAdminIntegraciones from '../pages/PlatformAdminIntegraciones';
import ImportarHistorico from '../pages/ImportarHistorico';
import FacturacionPresupuestosPage from '../pages/FacturacionPresupuestos/FacturacionPresupuestosPage';
import PlatformAdminCalidadChatbot from '../pages/PlatformAdminCalidadChatbot';
// ... etc

const PlatformAdminRoutes = () => (
    <Routes>
        <Route element={<PlatformAdminLayout />}> {/* Usa el layout correcto */}
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<PlatformAdminDashboard />} />
            <Route path="calidad-chatbot" element={<PlatformAdminCalidadChatbot />} />
            <Route path="metricas" element={<MetricasPlataforma />} />
            <Route path="configuracion-plataforma" element={<PlatformAdminConfiguracion />} />
            <Route path="agregar-nuevo" element={<GestionAgregarNuevo />} />
            <Route path="configuracion/notificaciones" element={<PlatformAdminNotificaciones />} />
            <Route path="configuracion/sesiones" element={<ControlSesiones />} />
            <Route path="configuracion/integraciones" element={<PlatformAdminIntegraciones />} />
            <Route path="configuraciones/importar-historico" element={<ImportarHistorico />} />
            <Route path="configuracion-planes" element={<GestionPlanes />} />
            <Route path="fraccionamientos" element={<ListaFraccionamientos />} />
            <Route path="fraccionamientos/:fraccId" element={<EditarFraccionamiento />} />
            <Route path="usuarios-autenticados" element={<GestionarUsuariosAutenticados />} />
            <Route path="registrar-fraccionamiento" element={<RegistrarFraccionamiento />} />
            <Route path="solicitudes-demo" element={<GestionaSolicitudes />} />
            <Route path="soporte/solicitudes" element={<SolicitudesSoporte />} />
            <Route path="comunidad" element={<Comunidad />} />
            <Route path="comunidad/chat" element={
                <ModuloGuard moduloKey="chat_comunitario">
                    <ChatComunitario />
                </ModuloGuard>
            } />
            <Route path="comunidad/documentos" element={<ValidacionDocumentos />} />
            <Route path="facturacion-presupuestos" element={<FacturacionPresupuestosPage />} />
            {/* ... el resto de las rutas del platformadmin ... */}
        </Route>
    </Routes>
);

export default PlatformAdminRoutes;